import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';

import MinimalLayout from 'layout/MinimalLayout';
const ApiDoc = Loadable(lazy(() => import('views/API')));



// 新增独立API路由配置
const ApiRoutes = {
  path: 'apidocx',
  element: <MinimalLayout />,
  children: [
    {
      path: 'seededit',
      element: <ApiDoc />
    },
    {
      path: 'qwen-image',
      element: <ApiDoc />
    },
    {
      path: 'clothes',
      element: <ApiDoc />
    },
    {
      path: 'qwen-image-edit',
      element: <ApiDoc />
    }
  ]
};


export default ApiRoutes;
